import React, { useRef } from "react";
import { useClickOutside } from "../../hooks/useClickOutside";
import "./style.scss";

export interface DropdownItem {
  id: string;
  title: string;
  value: any;
  children?: DropdownItem[];
}

interface DropdownProps {
  items: DropdownItem[];
  isOpen: boolean;
  onClose: () => void;
  triggerRef: React.RefObject<HTMLElement>;
  onSelect: (item: DropdownItem) => void;
  selectedItem?: DropdownItem;
  disableParentSelecting?: boolean;
}

export const Dropdown: React.FC<DropdownProps> = ({
  items,
  isOpen,
  onClose,
  triggerRef,
  onSelect,
  selectedItem,
  disableParentSelecting = false,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useClickOutside(dropdownRef, triggerRef, onClose);

  const renderDropdownItems = (items: DropdownItem[] = []): JSX.Element[] => {
    return items.map(item => (
      <React.Fragment key={item.id}>
        <div
          className={`dropdown-item ${
            item.id === selectedItem?.id &&
            (!disableParentSelecting || !item.children?.length)
              ? "selected"
              : ""
          } ${
            disableParentSelecting && item.children?.length
              ? "non-selectable"
              : ""
          }`}
          onClick={e => {
            e.stopPropagation();
            if (
              !disableParentSelecting ||
              !item.children ||
              item.children.length === 0
            ) {
              onSelect(item);
            }
          }}
        >
          {item.title}
        </div>
        {item.children && item.children.length > 0 && (
          <div className="dropdown-submenu">
            {renderDropdownItems(item.children)}
          </div>
        )}
      </React.Fragment>
    ));
  };

  if (!isOpen) return null;

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      {renderDropdownItems(items)}
    </div>
  );
};
